// extracted by mini-css-extract-plugin
export default {"myPurchases":"MyPurchases_myPurchases__0xcxL","title":"MyPurchases_title__ssCur","empty":"MyPurchases_empty__PuI77"};